import axios from "axios";
import { installRefreshInterceptor } from "./refresh-interceptor";

const api = axios.create({
    headers: {
        "Content-Type": "application/json",
    },
});

/**
 * On a 401 (expired access token), silently refresh via the rotating refresh token
 * and retry the original request. If the refresh fails, the user is sent to login.
 */
installRefreshInterceptor(api);

/**
 * Attach the active company to API requests.
 *
 * API routes do not use the web session, so the active company must be
 * passed explicitly via a request header. Read from window.bo at request
 * time so initialization order does not matter.
 */
api.interceptors.request.use((config) => {
    if (window.bo && window.bo.companyId) {
        config.headers["X-Bo-Company-Id"] = window.bo.companyId;
    }
    return config;
});

export default api;
